import React, { FC } from 'react';

import { HarvestSummaryTabProps } from './HarvestSummary.props';

import HarvestSummaryTabContent from './HarvestSummaryTabContent';
const ArchivedHarvestSummary: FC<HarvestSummaryTabProps> = (props) => {
  return (
    <HarvestSummaryTabContent
      {...props}
      isArchived={true}></HarvestSummaryTabContent>
  );
};

export default ArchivedHarvestSummary;
